import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

const PasswordField = ({
  name,
  label,
  onChange,
  onBlur,
  value,
  error,
  touched,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mb-3 tx-semibold">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <div className="relative w-full">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onBlur={onBlur}
          className={`w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none w-full pr-10 ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-md border py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-300`}
          name={name}
          onChange={onChange}
        />
        <span
          className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
          onClick={() => setShowPassword((prev) => !prev)}
        >
          {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
        </span>
      </div>
      {error && <div className="text-red-600 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default PasswordField;
